import { createFileRoute } from '@tanstack/react-router'

import { PassCardBindSuccess } from '@/pages/pass-card-bind-success'

export const Route = createFileRoute('/_protected/pass-card-bind/success')({
    component: () => <PassCardBindSuccess />,
    validateSearch: (search) => {
        return {
            cardPanLast4: search.cardPanLast4 ? String(search.cardPanLast4) : undefined,
        }
    },
})
